import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 目的港派车List
export function getTruckingInfoPodList(data) {
  return request({
    url: URL.booking.integratedJob.getTruckingInfoPodList,
    method: 'post',
    data
  })
}
